<template>
  <div class="login-form">
    <div class="login-wrap">
      <img src="./assets/youtv_logo_isp_console.svg" alt="" width="220px">
      <el-form label-width="120px" class="demo-ruleForm" label-position="top" v-on:submit.prevent="submit">
        <el-form-item label="Email" prop="email">
          <div class="el-input">
            <input
              class="el-input__inner"
              type="email"
              auto-complete="off"
              v-model="email"
              required
              @keyup.enter="submit" >
            </input>
          </div>
        </el-form-item>
        <el-form-item label="Password" prop="pass"><div class="el-input">
          <input type="password" auto-complete="off" v-model="password" @keyup.enter="submit" class="el-input__inner"></input>
        </div></el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" :loading="loading">Sign in</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import * as Api from './api.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {

    beforeRouteEnter (to, from, next) {
      next(vm => {
        document.title = 'Login • youtv ISP Console'
        vm.isUserLoggedIn ? next('/') : next()
      })
    },

    computed: {
      ...mapGetters(['user', 'authStatus', 'authError', 'isUserLoggedIn']),
      ready () {
        return this.$store.state.appReady
      }
    },

    data () {
      return {
        loading: false,
        email: null,
        password: null
      }
    },

    methods: {
      submit () {
        if (this.loading) return
        this.loading = true
        this.login({'email':this.email, 'password': this.password})
      },
      showError (e) {
        this.$message({
          type: 'error',
          message: e
        })
      },
      ...mapActions(['login'])
    },

    watch: {
      authStatus (newS) {
        if (newS == 'successful' && this.isUserLoggedIn) {
          this.loading = false
          this.$router.push('/')
        } else if (newS == 'failed') {
          this.loading = false
          console.log(this.authError)
          let e = this.authError ? this.authError : 'Failed to sign in'
          this.showError(e)
        }
      },
      // isUserLoggedIn (newU) {
      //   if (newU) {
      //     this.loading = false
      //     this.$router.push('/')
      //   }
      // },
      ready (ready) {
        if (ready) {
          this.loading = false
          this.$router.push('/')
        }
      }
    }

  }
</script>

<style lang="scss">
html, body, #app, .page-container {
  height: 100%;
}
.login-form {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(244, 245, 247, 0.47);

  .login-wrap {
    border: 1px solid #eaeefb;
    background-color: white;
    border-radius: 4px;
    padding: 40px 60px;
    text-align: center;
    transition: .2s;
    &:hover {
      box-shadow: 0 0 8px 0 rgba(232, 237, 250, .6), 0 2px 4px 0 rgba(232, 237, 250, .5);
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
  }
  img {
    display: block;
    margin: 0 auto;
  }

  form {
    text-align: left
  }
}
</style>